/* ==========================================================================
   Daps 15% pop-up. Markup + settings: sections/daps-popup.liquid. Design: "1A → 2B → 3C".
   1A pick a boost moment (advances ~250ms after the tap) → 2B email → 3C confirmation.
   No X. Exits: 1A/2B skip link (counts as a dismissal), 3C "Keep shopping", Esc.

   Submitting subscribes the email to the Klaviyo welcome list through Klaviyo's public
   client API (public key only); that list's flow emails the 15% code. 3C shows only after
   Klaviyo accepts the subscribe. The 1A answer is saved on the profile as
   primary_energy_moment (workout / work_study / late_night).

   When it opens:
     - product page (buy box present): an engaged non-buyer — buy box seen, then 25s on the page plus
       300px scrolled past the buy box, or 50s on the page (desktop: exit intent after 25s). Never while
       they are using the buy box or the cart drawer (see "Product page" below);
     - other pages: N seconds on the site (counted across pages this visit) OR M% scrolled, whichever
       comes first; never at page load; desktop also on exit intent. Never on the store locator or the
       Loop subscription portal (/a/loop_subscriptions).
   At most once per visit. It stays away when:
     - this browser already signed up (here or via the product page's "Unlock 15%"),
     - it was closed recently (cool-downs are theme settings),
     - Klaviyo already knows this visitor, or a discount link was used,
     - this visit: it was already shown, something was added to cart, or "Unlock 15%" was opened,
     - a cart drawer, menu or other dialog is open (it waits instead).
   ?daps_popup=1 forces it open; ?daps_popup=test also skips the Klaviyo call.
   ========================================================================== */
(function () {
  "use strict";
  var root = document.querySelector("[data-dpop]");
  if (!root) return;
  var card = root.querySelector(".dpop__card");
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  var KEY = "daps_pop_v1", T0 = "daps_pop_t0", SKEY = "daps_pop_s";
  var DAY = 864e5;
  var cfg = {
    delay: (+root.getAttribute("data-delay") || 10) * 1000,
    scroll: (+root.getAttribute("data-scroll") || 40) / 100,
    exit: root.getAttribute("data-exit") === "true",
    cool1: (+root.getAttribute("data-cool1") || 14) * DAY,
    cool2: (+root.getAttribute("data-cool2") || 30) * DAY,
    list: root.getAttribute("data-list") || "",
    site: root.getAttribute("data-site") || "",
    source: root.getAttribute("data-source") || "Daps 15% pop-up"
  };
  var qs = (location.search.match(/[?&]daps_popup=([^&]+)/) || [])[1] || "";
  var FORCE = qs === "1" || qs === "test", MOCK = qs === "test";
  var EDITOR = root.getAttribute("data-editor") === "1";
  var MSG_INVALID = "That email looks incomplete. Check for a typo.";
  var MSG_FAILED = "Something went wrong. Please try again.";

  /* ---------- memory (per browser) ---------- */
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(m) { try { localStorage.setItem(KEY, JSON.stringify(m)); } catch (e) {} }
  function markSubmitted() { var m = load(); m.done = 1; save(m); }
  function cookie(name) { var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)")); return m ? decodeURIComponent(m[1]) : ""; }
  function klaviyoKnows() {
    var k = cookie("__kla_id");
    if (!k) return false;
    try { var j = JSON.parse(atob(k)); return !!(j.$exchange_id || j.$email || j.$kla_id); } catch (e) { return false; }
  }
  /* this visit only (sessionStorage): shown = already displayed once, atc = added to cart,
     offer = opened the product page's "Unlock 15%" */
  function sess() { try { return JSON.parse(sessionStorage.getItem(SKEY)) || {}; } catch (e) { return {}; } }
  function flag(k) { if (FORCE || EDITOR) return; try { var s = sess(); s[k] = 1; sessionStorage.setItem(SKEY, JSON.stringify(s)); } catch (e) {} }
  function suppressed() {
    var m = load();
    if (m.done) return true;
    if (m.until && Date.now() < m.until) return true;
    if (cookie("discount_code")) return true;
    if (klaviyoKnows()) return true;
    var s = sess();
    if (s.shown || s.atc || s.offer) return true;
    return false;
  }
  /* the product page's own "Unlock 15%": opening it ends the pop-up for this visit, submitting it
     counts as signing up (permanent, same as a pop-up sign-up) */
  function watchPdpOffer() {
    var P = window.DapsPDP;
    if (P && typeof P.on === "function") P.on(function (S) {
      if (!S) return;
      if (S.emailOpen || S.offerSent) flag("offer");
      if (S.offerSent) { markSubmitted(); if (open) close(false); }
    });
  }
  /* any successful add to cart, from any button on any page, ends the pop-up for this visit */
  function watchAddToCart() {
    if (!window.PerformanceObserver) return;
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) {
          if (e.name.indexOf("/cart/add") === -1) return;
          var st = e.responseStatus; /* not reported by every browser: then count the request itself */
          if (!st || (st >= 200 && st < 300)) flag("atc");
        });
      }).observe({ type: "resource", buffered: true });
    } catch (e) {}
  }

  /* ---------- elements + state ---------- */
  var sheet = $("[data-dpop-sheet]"), hand = $(".dpop__hand"), handwrap = $("[data-dpop-handwrap]");
  var email = $("[data-dpop-email]"), submit = $("[data-dpop-submit]"), fail = $("[data-dpop-fail]"), live = $("[data-dpop-live]");
  var opts = $$("[data-dpop-opt]");
  var open = false, step = 1, choice = "", busy = false, lastFocus = null, holdT = 0, swapT = 0, settleT = 0;
  var reduced = !!(window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches);
  var touch = !!(window.matchMedia && matchMedia("(hover: none) and (pointer: coarse)").matches);
  function valid(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || "").trim()); }
  function say(msg) { live.textContent = ""; if (msg) setTimeout(function () { live.textContent = msg; }, 30); }
  function focusEl(el) { if (el) try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }

  function setStep(n) {
    step = n;
    card.setAttribute("data-step", String(n));
    card.setAttribute("aria-labelledby", "dpop-h" + n);
    sheet.scrollTop = 0;
    if (n === 1) fitHand();
  }
  /* screen change: old content fades out (160ms) → layout switches → the white sheet glides from its
     old top edge to the new one (460ms) while the new headline and sheet content fade in.
     Reduced motion: instant swap. */
  function go(n, after) {
    clearTimeout(swapT); clearTimeout(settleT);
    if (reduced) { setStep(n); if (after) after(); return; }
    card.classList.add("is-leaving");
    swapT = setTimeout(function () {
      var before = sheet.getBoundingClientRect().top;
      setStep(n);
      var delta = before - sheet.getBoundingClientRect().top;
      card.classList.remove("is-leaving");
      card.classList.add("is-entering");
      sheet.style.transition = "none";
      sheet.style.transform = delta ? "translateY(" + Math.round(delta) + "px)" : "";
      void sheet.offsetHeight;
      sheet.style.transition = "";
      sheet.style.transform = "";
      card.classList.add("is-settling");
      void card.offsetHeight;
      card.classList.remove("is-entering");
      settleT = setTimeout(function () { card.classList.remove("is-settling"); }, 520);
      if (after) setTimeout(after, 240);
    }, 170);
  }
  function setInvalid(on) {
    email.setAttribute("aria-invalid", on ? "true" : "false");
  }
  function setFail(on) {
    fail.hidden = !on;
    fail.textContent = on ? MSG_FAILED : "";
  }
  function pick(btn) {
    choice = btn.getAttribute("data-dpop-opt");
    opts.forEach(function (b) {
      var on = b === btn;
      b.setAttribute("aria-checked", on ? "true" : "false");
      b.tabIndex = on ? 0 : -1;
    });
  }

  /* 1A hand, right edge flush with the screen edge (CSS right:0 — any further left would show the
     cut-off wrist). The box bottom sits at ~81% of the image height; the palm below it may tuck behind
     the sheet. The image's top-left is empty, so the fingertips can rise beside the headline: SHAPE is
     the left edge of the visible hand per image row (measured from the PNG's alpha). Use the largest
     width up to MAX_W (88% of min(300px, 78vw)) whose box clears the sheet by GAP and whose outline stays
     PAD clear of every line of headline/logo text; on tall screens lift it SPARE of the way into the
     free blue above. Hidden if it would be smaller than 120px wide. */
  var BOX_BOTTOM = 0.81, RATIO = 1282 / 1227, PAD = 10, GAP = 20, SPARE = 0.6;
  var SHAPE = [[0.04, 1], [0.048, 0.535], [0.072, 0.445], [0.096, 0.335], [0.12, 0.29], [0.144, 0.25],
    [0.167, 0.22], [0.191, 0.205], [0.215, 0.19], [0.239, 0.175], [0.263, 0.165], [0.287, 0.155],
    [0.335, 0.16], [0.359, 0.115], [0.6, 0.11], [0.72, 0.145], [0.81, 0.315]];
  function edgeAt(y) { /* left edge (fraction of width) of the hand at image row y (fraction of height) */
    if (y < SHAPE[0][0] || y > 0.81) return 1;
    for (var i = 1; i < SHAPE.length; i++) {
      if (y <= SHAPE[i][0]) return Math.min(SHAPE[i - 1][1], SHAPE[i][1]);
    }
    return 1;
  }
  function textBoxes() {
    /* text line boxes in hero coordinates; screen rects are mapped back through each element's
       layout offsets so open/slide transforms can't skew them */
    var out = [];
    [$("#dpop-h1"), $(".dpop__logo")].forEach(function (el) {
      if (!el) return;
      var er = el.getBoundingClientRect(), k = er.width ? el.offsetWidth / er.width : 1;
      var add = function (r) {
        if (!r.width) return;
        out.push({ t: el.offsetTop + (r.top - er.top) * k, b: el.offsetTop + (r.bottom - er.top) * k,
          r: el.offsetLeft + (r.right - er.left) * k });
      };
      if (el.tagName === "IMG") { add(er); return; }
      var tw = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), n, rg = document.createRange();
      while ((n = tw.nextNode())) {
        if (!n.nodeValue.trim()) continue;
        rg.selectNodeContents(n);
        Array.prototype.forEach.call(rg.getClientRects(), add);
      }
    });
    return out;
  }
  function fitHand() {
    if (!handwrap) return;
    var cw = card.clientWidth, st = sheet.offsetTop, boxes = textBoxes();
    function fits(w, top) {
      var h = w * RATIO, left = cw - w;
      if (top + 0.048 * h < 8) return false;    /* fingertips stay on screen */
      return boxes.every(function (b) {
        for (var y = b.t - 2; y <= b.b + 2; y += 2) {
          if (left + edgeAt((y - top) / h) * w < b.r + PAD) return false;
        }
        return true;
      });
    }
    var w = Math.floor(Math.min(300, cw * 0.78) * 0.88), top = 0, ok = false;
    for (; w >= 120; w -= 2) {
      top = st - GAP - BOX_BOTTOM * w * RATIO;  /* as low as the sheet allows */
      if ((ok = fits(w, top))) break;
    }
    if (ok) { /* spare blue above (tall screens): lift the hand part of the way up into it */
      var hi = top;
      while (hi - 2 > 0 && fits(w, hi - 2)) hi -= 2;
      top -= (top - hi) * SPARE;
    }
    handwrap.style.width = Math.max(120, w) + "px";
    handwrap.style.top = Math.round(top) + "px";
    handwrap.style.visibility = ok ? "" : "hidden";
  }

  /* ---------- open / close ---------- */
  /* lock page scroll without the page jumping sideways when the scrollbar disappears */
  function lockScroll(on) {
    var de = document.documentElement;
    if (on) {
      var sw = window.innerWidth - de.clientWidth;
      de.style.overflow = "hidden";
      if (sw > 0) de.style.paddingRight = sw + "px";
    } else {
      de.style.overflow = ""; de.style.paddingRight = "";
    }
  }
  function blockedNow() {
    if (document.querySelector(".cdraw.is-open,[data-dp-drawer].is-open,.navdrawer.is-open,.is-open[aria-modal='true']")) return true;
    if (document.body.style.overflow === "hidden") return true;
    var a = document.activeElement;
    if (a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) && !root.contains(a)) return true;
    return false;
  }
  function warmImages() { if (hand) hand.loading = "eager"; }
  if (hand) hand.addEventListener("load", function () { if (open && step === 1) fitHand(); });
  /* the stylesheet loads without blocking the page; never show the pop-up before it applies */
  var styleTries = 0;
  function styled() { return getComputedStyle(root).position === "fixed"; }
  function openPop() {
    warmImages();
    if (open) return;
    if (!FORCE && !EDITOR && suppressed()) return;
    if (!FORCE && !EDITOR && blockedNow()) { setTimeout(openPop, 4000); return; }
    if (!styled()) { if (++styleTries <= 100) setTimeout(openPop, 100); return; }
    stopTriggers();
    open = true; lastFocus = document.activeElement;
    if (hand) try { hand.fetchPriority = "high"; } catch (e) {}
    choice = ""; busy = false;
    opts.forEach(function (b, i) { b.setAttribute("aria-checked", "false"); b.tabIndex = i === 0 ? 0 : -1; });
    email.value = ""; setInvalid(false); setFail(false); say("");
    root.hidden = false;
    lockScroll(true);
    setStep(1);
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add("is-open"); }); });
    setTimeout(function () { focusEl($("#dpop-h1")); }, 60);
    flag("shown"); /* once per visit; screens 2 and 3 are the same display */
    track("daps_popup_shown");
  }
  /* counted = closed before signing up (skip link, Esc) → cool-down */
  function close(counted) {
    if (!open) return;
    open = false;
    clearTimeout(holdT); clearTimeout(swapT); clearTimeout(settleT); holdT = 0;
    root.classList.remove("is-open");
    setTimeout(function () { root.hidden = true; card.classList.remove("is-leaving", "is-entering", "is-settling"); sheet.style.transform = ""; lockScroll(false); }, 420);
    if (counted && !EDITOR) {
      var m = load(); m.n = (m.n || 0) + 1; m.until = Date.now() + (m.n >= 2 ? cfg.cool2 : cfg.cool1); save(m);
      track("daps_popup_dismissed", { step: step });
    }
    if (lastFocus && lastFocus.focus) focusEl(lastFocus);
  }

  /* ---------- clicks ---------- */
  root.addEventListener("click", function (e) {
    var t = e.target.closest("button");
    if (!t || !root.contains(t)) return;
    if (t.hasAttribute("data-dpop-opt")) {
      if (step !== 1 || holdT) return;
      pick(t);
      holdT = setTimeout(function () {
        holdT = 0;
        go(2, function () { focusEl(touch ? $("#dpop-h2") : email); });
      }, 250);
      return;
    }
    if (t.hasAttribute("data-dpop-wrong")) { go(2, function () { focusEl(email); try { email.select(); } catch (x) {} }); return; }
    if (t.hasAttribute("data-dpop-close")) { close(false); return; }
    if (t.hasAttribute("data-dpop-dismiss")) { close(step !== 3); return; }
  });

  /* ---------- keyboard: Esc, focus trap, radiogroup arrows ---------- */
  root.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { e.preventDefault(); close(step !== 3); return; }
    if (e.key === "Tab") {
      var f = $$("button,input").filter(function (el) { return el.offsetParent !== null && el.tabIndex >= 0; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || !root.contains(a) || a.tagName === "H1")) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
      return;
    }
    if (step === 1 && /^(ArrowDown|ArrowUp|ArrowLeft|ArrowRight|Home|End)$/.test(e.key)) {
      var i = opts.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var n = e.key === "Home" ? 0 : e.key === "End" ? opts.length - 1 :
        (i + (e.key === "ArrowDown" || e.key === "ArrowRight" ? 1 : opts.length - 1)) % opts.length;
      opts.forEach(function (b, j) { b.tabIndex = j === n ? 0 : -1; });
      opts[n].focus();
    }
  });

  /* ---------- 2B: validate on submit, then re-check while in error ---------- */
  email.addEventListener("input", function () {
    if (email.getAttribute("aria-invalid") === "true" && valid(email.value)) { setInvalid(false); say(""); }
    if (!fail.hidden) setFail(false);
  });
  $("[data-dpop-form]").addEventListener("submit", function (e) {
    e.preventDefault();
    if (busy) return;
    var v = email.value.trim();
    if (!valid(v)) { setInvalid(true); say(MSG_INVALID); focusEl(email); return; }
    setInvalid(false); setFail(false);
    busy = true; submit.setAttribute("aria-busy", "true");
    subscribe(v).then(function (ok) {
      busy = false; submit.setAttribute("aria-busy", "false");
      if (!ok) { setFail(true); say(MSG_FAILED); return; }
      markSubmitted();
      $("[data-dpop-sent]").textContent = v;
      track("daps_popup_submitted", { energy_moment: choice });
      go(3, function () { focusEl($("#dpop-h3")); });
    });
  });

  /* ---------- Klaviyo (public client API) ---------- */
  var REV = "2024-10-15";
  function siteId() {
    if (cfg.site) return cfg.site;
    var sc = document.querySelectorAll("script[src*='klaviyo']");
    for (var i = 0; i < sc.length; i++) {
      var m = sc[i].src.match(/company_id=([A-Za-z0-9]+)/) || sc[i].src.match(/onsite\/js\/([A-Za-z0-9]{6})\//);
      if (m) return m[1];
    }
    return "";
  }
  function kPost(path, site, body) {
    return fetch("https://a.klaviyo.com/client/" + path + "/?company_id=" + encodeURIComponent(site), {
      method: "POST", headers: { "Content-Type": "application/json", revision: REV }, body: JSON.stringify(body)
    }).then(function (r) { return r.status >= 200 && r.status < 300; }).catch(function () { return false; });
  }
  function subscribe(addr) {
    if (MOCK) return new Promise(function (res) { setTimeout(function () { res(!/fail@/i.test(addr)); }, 900); });
    var site = siteId();
    if (!cfg.list || !site) { if (window.console) console.warn("[Daps pop-up] Klaviyo list or key missing — nothing sent."); return Promise.resolve(false); }
    var profile = { data: { type: "profile", attributes: { email: addr } } };
    var sub = { data: { type: "subscription", attributes: { custom_source: cfg.source, profile: profile }, relationships: { list: { data: { type: "list", id: cfg.list } } } } };
    return kPost("subscriptions", site, sub).then(function (ok) {
      if (!ok) return false;
      /* best effort after the subscribe is confirmed: save the answer on the profile + log the request */
      var props = { primary_energy_moment: choice || "" };
      kPost("profiles", site, { data: { type: "profile", attributes: { email: addr, properties: props } } });
      kPost("events", site, { data: { type: "event", attributes: {
        properties: { source: cfg.source, primary_energy_moment: choice || "", list_id: cfg.list, page: location.pathname },
        metric: { data: { type: "metric", attributes: { name: "Popup 15% Code Requested" } } },
        profile: { data: { type: "profile", attributes: { email: addr } } } } } });
      return true;
    });
  }

    function track(name, props) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, props || {}); } catch (e) {}
    /* also send pop-up events to Microsoft Clarity (tracking only, no visual change) */
    try {
      var c = window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      c("event", name);
      if (props && props.step) c("set", "daps_popup_dismiss_step", String(props.step));
      if (props && props.energy_moment) c("set", "daps_popup_energy", String(props.energy_moment));
    } catch (e) {}
  }

  /* ---------- layout upkeep: hand size, and the 2B button above the phone keyboard ---------- */
  window.addEventListener("resize", function () { if (open && step === 1) fitHand(); });
  if (window.visualViewport) {
    var vv = window.visualViewport;
    var keepCtaVisible = function () {
      if (!open || step !== 2) return;
      var bottom = submit.getBoundingClientRect().bottom, visible = vv.height + vv.offsetTop;
      if (bottom > visible - 8) sheet.scrollTop += bottom - visible + 16;
    };
    vv.addEventListener("resize", keepCtaVisible); vv.addEventListener("scroll", keepCtaVisible);
    vv.addEventListener("resize", function () { if (open && step === 1) fitHand(); });
  }

  /* ---------- triggers ---------- */
  var timer = 0;
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h >= cfg.scroll) openPop();
  }
  function onLeave(e) { if (!e.relatedTarget && e.clientY <= 0) { if (pdp) pdpExit(); else openPop(); } }
  function stopTriggers() {
    clearTimeout(timer); clearTimeout(pdpT); clearTimeout(seenT);
    window.removeEventListener("scroll", onScroll);
    window.removeEventListener("scroll", onPdpScroll);
    document.removeEventListener("mouseout", onLeave);
    BUY_EVENTS.forEach(function (ev) { document.removeEventListener(ev, markBuying, true); });
    if (io) { io.disconnect(); io = null; }
    if (mo) { mo.disconnect(); mo = null; }
  }

  /* Product page (the buy box is on the page): show to an engaged non-buyer, not a fast scroller.
     Eligible when the buy box has been seen (40%+ of it, or half the screen, for 1s) AND either
       - 25s on this page AND they kept going 300px past the end of the buy box, or
       - 50s on this page (they stayed but didn't scroll on), or
       - desktop exit intent after 25s.
     Time only counts while the tab is visible. Even when eligible it waits while the cart drawer is open
     (and for 10s after it closes), for 4s after any tap in the buy box / sticky bar, and while another
     menu, dialog or form field is in use. Other pages keep the site-wide time/scroll trigger. */
  var PDP_MIN = 25000, PDP_LONG = 30000, PAST = 300, SEEN_MS = 1000, BUY_IDLE = 4000, DRAWER_GRACE = 10000;
  var BUY_EVENTS = ["pointerdown", "keydown", "change", "focusin"];
  var pdp = null, seen = false, past = false, exitAsk = false, lastBuy = 0, drawerShut = 0;
  var pdpT = 0, seenT = 0, scrollRaf = 0, io = null, mo = null;
  var visMs = 0, visFrom = document.hidden ? 0 : Date.now() - Math.round(window.performance ? performance.now() : 0);
  function onPage() { return visMs + (visFrom ? Date.now() - visFrom : 0); }
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) { if (visFrom) { visMs += Date.now() - visFrom; visFrom = 0; } }
    else { if (!visFrom) visFrom = Date.now(); if (pdp) checkPdp(); }
  });
  function drawerOpen() { return !!document.querySelector("[data-dp-drawer].is-open,.cdraw.is-open"); }
  function later(ms) { clearTimeout(pdpT); pdpT = setTimeout(checkPdp, Math.max(50, ms)); }
  function checkPdp() {
    if (open || !pdp) return;
    if (suppressed()) { stopTriggers(); return; }
    if (!seen) return; /* seeing the buy box starts the checks */
    var t = onPage();
    if (t >= PDP_MIN - 4000) warmImages(); /* the hand loads a few seconds before it can open */
    var ready = (t >= PDP_MIN && (past || exitAsk)) || t >= PDP_LONG;
    if (!ready) { later((t < PDP_MIN - 4000 ? PDP_MIN - 4000 : t < PDP_MIN ? PDP_MIN : PDP_LONG) - t); return; }
    if (document.hidden || drawerOpen()) return; /* re-checked when the tab returns / the drawer closes */
    var wait = Math.max(drawerShut + DRAWER_GRACE, lastBuy + BUY_IDLE) - Date.now();
    if (wait > 0) { later(wait); return; }
    openPop(); /* still waits on menus, dialogs and focused fields (blockedNow) */
  }
  function pdpExit() {
    if (!seen || onPage() < PDP_MIN) return;
    exitAsk = true; checkPdp(); exitAsk = false; /* a moment, not a standing request */
  }
  function onPdpScroll() {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = 0;
      if (past || pdp.getBoundingClientRect().bottom > window.innerHeight - PAST) return;
      past = true; window.removeEventListener("scroll", onPdpScroll); checkPdp();
    });
  }
  function markBuying(e) {
    var t = e.target;
    if (t && t.closest && t.closest("[data-dp-buy],[data-dp-sticky],[data-dp-to-buy]")) lastBuy = Date.now();
  }
  function startPdp() {
    BUY_EVENTS.forEach(function (ev) { document.addEventListener(ev, markBuying, true); });
    var d = document.querySelector("[data-dp-drawer],.cdraw");
    if (d && window.MutationObserver) {
      var was = d.classList.contains("is-open");
      mo = new MutationObserver(function () {
        var now = d.classList.contains("is-open");
        if (was && !now) { drawerShut = Date.now(); checkPdp(); }
        was = now;
      });
      mo.observe(d, { attributes: true, attributeFilter: ["class"] });
    }
    var seeIt = function () {
      seen = true;
      if (io) { io.disconnect(); io = null; }
      window.addEventListener("scroll", onPdpScroll, { passive: true }); onPdpScroll();
      checkPdp();
    };
    if (!window.IntersectionObserver) { seeIt(); }
    else {
      io = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1], h = e.rootBounds ? e.rootBounds.height : window.innerHeight;
        clearTimeout(seenT);
        if (e.isIntersecting && (e.intersectionRatio >= 0.4 || e.intersectionRect.height >= h * 0.5)) seenT = setTimeout(seeIt, SEEN_MS);
      }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8, 1] });
      io.observe(pdp);
    }
    if (cfg.exit && window.matchMedia && matchMedia("(hover: hover) and (pointer: fine)").matches) document.addEventListener("mouseout", onLeave);
  }

  function start() {
    watchPdpOffer();
    watchAddToCart();
    if (EDITOR) { openPop(); return; }
    if (FORCE) { setTimeout(openPop, 300); return; }
    if (/\/pages\/store-locator(\/|$)|\/a\/loop_subscriptions(\/|$)/.test(location.pathname)) return; /* people looking for a store, or managing their subscription */
    if (suppressed()) return;
    pdp = document.querySelector("[data-dp-buy]");
    if (pdp) { startPdp(); return; }
    var t0 = 0;
    try { t0 = +sessionStorage.getItem(T0) || 0; if (!t0) { t0 = Date.now(); sessionStorage.setItem(T0, String(t0)); } } catch (e) { t0 = Date.now(); }
    var wait = Math.max(3000, cfg.delay - (Date.now() - t0)); /* never on page load */
    timer = setTimeout(openPop, wait);
    /* fetch the hand image a few seconds before it opens, so it doesn't pop in during the fade */
    setTimeout(warmImages, Math.max(1500, wait - 4000));
    setTimeout(function () {
      window.addEventListener("scroll", onScroll, { passive: true });
      if (cfg.exit && window.matchMedia && matchMedia("(hover: hover) and (pointer: fine)").matches) document.addEventListener("mouseout", onLeave);
    }, 3000);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();

  /* theme editor: re-open when the section re-renders */
  document.addEventListener("shopify:section:load", function (e) { if (e.target && e.target.querySelector && e.target.querySelector("[data-dpop]")) location.reload(); });
})();
